export default `
  query getBoundedContext($workflowId: ID!, $id: ID!) {
    getBoundedContext(workflowId: $workflowId, id: $id) {
      id
      name
      templateId
      githubAccountLogin
      githubRepo
      githubBranch
      codeGenerationStatus
      codeGenerationError
    }
  }
`
